module.exports = __webpack_public_path__ + "assets/cbc1f8243ed783e49bfafd59b8bfa83f.mp3";